import React from 'react';
import { Flex, Heading } from '@grubhubprod/gh-cookbook-react';

export interface GroceriesStepNumberProps {
  number: number;
}

export function GroceriesStepNumber({
  number,
}: GroceriesStepNumberProps): JSX.Element {
  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      bg="accentBrand"
      borderRadius="pill"
      width="50px"
      height="50px"
      flexShrink={0}
    >
      <Heading variant="h1" color="onColorAll">
        {number}
      </Heading>
    </Flex>
  );
}
